import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { catchError, map, retry, tap } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { ConfigurationResponse } from '../../shared/models/configuration.response';
import { Country } from '../../shared/models/country.model';
import { CountryResponse } from '../../shared/models/country.response.model';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class ParametersService {
  private urlBase = `${environment.host}ms-parameter/api/v1/parameter/`;

  country: Country = {
    code: '',
    shortName: ''
  };

  constructor(private httpService: HttpService) {}

  countries(): Observable<Country[]> {
    const api = `${this.urlBase}country`;
    this.httpService.uri = api;
    return this.httpService
      .execGetJson()
      .pipe(map((response: CountryResponse) => response.data));
  }

  /**
   * Obtiene los parametros de configuracion de la app
   */
  configuration() {
    const api = `${this.urlBase}configuration`;
    this.httpService.uri = api;
    this.httpService
      .execGetJson()
      .pipe(
        retry(5),
        map(data => data.data.country),
        tap(country => (this.country = country)),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }
}
